export default __webpack_public_path__ + "static/media/환자용_교육자료.d975315c.png";